import Vue from "vue";
import VueResource from "vue-resource";
import { API_ROOT } from "../config";
Vue.use(VueResource);
const base = API_ROOT + "messaging/projects/{projectId}";
const resource = (suffix) => Vue.resource(base + suffix);
const Projects = Vue.resource(API_ROOT + "messaging/projects");
export default {
  projects: () => Projects.get(),
  upload: (projectId, conversationId, input) =>
    resource("/conversations/{conversationId}/attachments").save(
      { projectId, conversationId },
      input
    ),
  attachment: (projectId, conversationId, attachmentId) =>
    resource("/conversations/{conversationId}/attachments/{attachmentId}").get({
      projectId,
      conversationId,
      attachmentId,
    }),
  transcribe: (projectId, input) =>
    Vue.resource(API_ROOT + "agent-projects/{projectId}/voice/transcribe").save(
      { projectId },
      input
    ),
  synthesize: (projectId, input) =>
    Vue.resource(API_ROOT + "agent-projects/{projectId}/voice/synthesize").save(
      { projectId },
      input
    ),
  unread: (projectId) => resource("/unread").get({ projectId }),
  conversations: (projectId, before) =>
    resource("/conversations").get({ projectId, before }),
  conversation: (projectId, conversationId) =>
    resource("/conversations/{conversationId}").get({
      projectId,
      conversationId,
    }),
  messages: (projectId, conversationId, after = 0, aroundMessageId) =>
    resource("/conversations/{conversationId}/messages").get({
      projectId,
      conversationId,
      after,
      aroundMessageId,
    }),
  send: (projectId, conversationId, message) =>
    resource("/conversations/{conversationId}/messages").save(
      { projectId, conversationId },
      message
    ),
  read: (projectId, conversationId, sequence) =>
    resource("/conversations/{conversationId}/read").update(
      { projectId, conversationId },
      { sequence }
    ),
  create: (projectId, input) =>
    resource("/conversations").save({ projectId }, input),
  recipients: (projectId, after) =>
    resource("/recipients").get({ projectId, after }),
  owner: (projectId, conversationId, input) =>
    resource("/conversations/{conversationId}/owner").update(
      { projectId, conversationId },
      input
    ),
  revise: (projectId, conversationId, messageId, input) =>
    resource("/conversations/{conversationId}/messages/{messageId}").update(
      { projectId, conversationId, messageId },
      input
    ),
  operations: (projectId) => resource("/operations").get({ projectId }),
  retry: (projectId, queue, operationId) =>
    resource("/operations/{queue}/{operationId}/retry").save(
      { projectId, queue, operationId },
      {}
    ),
  templates: (projectId) => resource("/templates").get({ projectId }),
  saveTemplate: (projectId, input) =>
    resource("/templates").save({ projectId }, input),
  updateTemplate: (projectId, templateId, input) =>
    resource("/templates/{templateId}").update(
      { projectId, templateId },
      input
    ),
  deleteTemplate: (projectId, templateId) =>
    resource("/templates/{templateId}").delete({ projectId, templateId }),
  broadcasts: (projectId) => resource("/broadcasts").get({ projectId }),
  broadcast: (projectId, input) =>
    resource("/broadcasts").save({ projectId }, input),
  preferences: (projectId) => resource("/preferences").get({ projectId }),
  savePreferences: (projectId, input) =>
    resource("/preferences").update({ projectId }, input),
  memories: (projectId) => resource("/memories").get({ projectId }),
  deleteMemory: (projectId, memoryId) =>
    resource("/memories/{memoryId}").delete({ projectId, memoryId }),
};
